import script from "./zyxds_notice.vue?vue&type=script&setup=true&lang=js"
export * from "./zyxds_notice.vue?vue&type=script&setup=true&lang=js"

import "./zyxds_notice.vue?vue&type=style&index=0&id=5c563e0d&lang=less"

const __exports__ = script;

export default __exports__